<template>
<el-drawer :title="drawer.title" :visible.sync="drawer.visible" size="30%">
    <el-form :model="ruleForm" :rules="rules" ref="accountRuleForm" labelPosition="top" class="ruleForm">
        <el-form-item label="品牌名称" prop="company_id">
            <el-select v-model="ruleForm.company_id" placeholder="品牌名称" filterable style="width: 100%;">
                <el-option v-for="(item,index) in companyList" :key="index" :label="item.title" :value="item.id"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="平台名称" prop="promoter_platform_id">
            <el-select v-model="ruleForm.promoter_platform_id" placeholder="平台名称" filterable style="width: 100%;">
                <el-option v-for="(item,index) in platformList" :key="index" :label="item.title" :value="item.id"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="门店名称" prop="promoter_store_id">
            <el-select v-model="ruleForm.promoter_store_id" placeholder="门店名称" filterable style="width: 100%;">
                <el-option v-for="(item,index) in storeList" :key="index" :label="item.title" :value="item.id"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="账户金额" prop="account_date_fee">
            <el-input v-model="ruleForm.account_date_fee" type="number"></el-input>
        </el-form-item>

        <el-form-item label="日期" prop="date">
            <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.date" style="width: 100%;"></el-date-picker>
        </el-form-item>

        <el-form-item>
            <el-button type="primary" @click="submitForm('accountRuleForm')">保存</el-button>
            <el-button @click="resetForm('accountRuleForm')">重置</el-button>
        </el-form-item>
    </el-form>
</el-drawer>
</template>

<script>
import '../css/common.css'

export default {
    data() {
        return {
            drawer: {
                title: '',
                visible: false
            },
            companyList: [],
            platformList: [],
            storeList: [],
            ruleForm: {
                id: 0,
                company_id: '',
                promoter_platform_id: '',
                promoter_store_id: '',
                account_date_fee: '',
                date: '',
            },
            rules: {
                company_id: [{
                    required: true,
                    message: '请选择品牌',
                    trigger: 'change'
                }],
                promoter_platform_id: [{
                    required: true,
                    message: '请选择平台',
                    trigger: 'change'
                }],
                promoter_store_id: [{
                    required: true,
                    message: '请选择门店',
                    trigger: 'change'
                }],
                payment: [{
                    required: true,
                    message: '请输入打款金额',
                    trigger: 'blur'
                }],
                date: [{
                    required: true,
                    message: '请选择时间',
                    trigger: 'change'
                }],
            }
        };
    },
    created() {
        this.getPickerData();
    },
    methods: {
        showDrawer(options) {
            let that = this;
            if (options == '') {
                this.drawer.title = '添加开户金额';
            } else {
                this.drawer.title = '编辑开户金额';
            }
            this.drawer.visible = true;
            if (options != '') {
                let url = '/api/promoter.account/read';
                this.$post(url, options).then(function (response) {
                    if (response.code == '200') {
                        that.ruleForm = response.data.row;
                    } else {
                        this.$message(response.msg);
                    }
                });
            }
        },

        getPickerData() {
            let that = this;
            let url = '/api/promoter.account/picker';
            this.$post(url).then(function (response) {
                if (response.code == '200') {
                    that.storeList = response.data.storeList;
                    that.platformList = response.data.platformList;
                    that.companyList = response.data.companyList;
                } else {
                    this.$message(response.msg);
                }
            });

        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let that = this;
                    let url = '';
                    if (this.ruleForm.id == '') {
                        url = '/api/promoter.account/create';
                    } else {
                        url = '/api/promoter.account/save';
                    }
                    this.$post(url, this.ruleForm).then(function (response) {
                        if (response.code == '200') {
                            that.drawer.visible = false;
                            that.resetForm(formName);
                            // that.$parent.doSearch();
                            that.$emit("getTableData");
                        } else {
                            that.$message(response.msg);
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    }
}
</script>
